import React from 'react';
import LinkWrapper from '../../../../archon/components/LinkWrapper/LinkWrapper';

export type BuildsQuickStatsSectionProps = {
  title: string;
  stats: (
    | QuickStatsTierViewModel
    | QuickStatsPrimaryTierListMetricViewModel
    | QuickStatsPrimaryMetricViewModel
    | QuickStatsMetricRankViewModel
  )[];
  tierListUrl: string;
};

type QuickStatsTierViewModel = {
  kind: 'tier';
  title: string;
  tier: string;
  color: string;
};

type QuickStatsPrimaryTierListMetricViewModel = {
  kind: 'primaryTierListMetric';
  title: string;
  rank: number;
  enumeration?: string;
  total: string;
  color: string | null;
};

type QuickStatsPrimaryMetricViewModel = {
  kind: 'metric';
  metric: 'dps' | 'hps';
  value: string;
  bottomLabel: string;
};

type QuickStatsMetricRankViewModel = {
  kind: 'rank';
  metric: 'dps' | 'hps';
  rank: number;
  enumeration?: string;
  total: string;
  color: string | null;
};

export default function BuildsQuickStatsSection({
  stats,
  title,
  tierListUrl,
}: BuildsQuickStatsSectionProps): JSX.Element | null {
  if (stats.length === 0) {
    return null;
  }

  return (
    <div
      className='builds-quick-stats-section'
      style={{
        // @ts-expect-error custom css attr
        ['--items']: stats.length,
      }}
    >
      <div className='builds-quick-stats-section-title-row'>
        <div />
        <div className='builds-quick-stats-section-title'>{title}</div>
        <div />
      </div>
      <div className='builds-quick-stats-section-row'>
        {stats.map((stat, index) => {
          return (
            <div className='builds-quick-stats-section-row__box' key={index}>
              <div className='builds-quick-stats-section-row__box-top'>
                {stat.kind === 'primaryTierListMetric'
                  ? stat.title
                  : stat.kind === 'metric' || stat.kind === 'rank'
                  ? stat.metric
                  : undefined}
              </div>
              <div className={'builds-quick-stats-section-row__box-center'}>
                <LinkWrapper
                  href={tierListUrl}
                  className={'builds-quick-stats-section__metric-link'}
                >
                  {stat.kind === 'metric' ? (
                    <span className={'builds-quick-stats-section__value'}>
                      {stat.value}
                    </span>
                  ) : stat.kind === 'rank' ||
                    stat.kind === 'primaryTierListMetric' ? (
                    <span
                      className={`builds-quick-stats-section__value ${
                        stat.enumeration
                          ? 'builds-quick-stats-section__value--with-enumeration'
                          : ''
                      } ${stat.color ? stat.color : ''}`}
                    >
                      {stat.rank}{' '}
                      {stat.enumeration ? (
                        <sup className='builds-quick-stats-section__enumeration'>
                          {stat.enumeration}
                        </sup>
                      ) : null}
                    </span>
                  ) : undefined}
                </LinkWrapper>
              </div>
              <div className='builds-quick-stats-section-row__box-bottom'>
                {stat.kind === 'primaryTierListMetric' || stat.kind === 'rank'
                  ? stat.total
                  : stat.kind === 'metric'
                  ? stat.bottomLabel
                  : undefined}
              </div>
            </div>
          );
        })}
      </div>
    </div>
  );
}
